module.exports = __webpack_public_path__ + "static/img/play.e5b4546.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/widget/play.png
// module id = i2H+
// module chunks = 11